import React from "react"

const ReadingModule = () => (
    <section class="lrws-section-1">
        <div class="container">
        <div class="listening-wrapper mt-5">
              <div class="row">
                <div class="col-md-4">
                  <div class="listening-image-wrapper">
                    <img src={require('../../images/reading-image.png')} alt="" />
                  </div>
                </div>
                <div class="col-md-8" >
                  <div class="listening-content-wrapper">
                    <h3 class="content-title">
                      Reading
                    </h3>
                    <ul>
                      <li>
                        <span>
                          <img src={require('../../images/questions.png')} alt="" />
                          <strong>Questions : </strong> 40 
                        </span>
                      </li>
                      <li>
                        <span>
                          <img src={require('../../images/duration.png')} alt="" />
                          <strong>Duration : </strong> 60 min
                        </span>
                      </li>
                    </ul>
                    <div class="listening-sections-wrapper">
                      <p class="content-sub-title pb-0">Sections</p>
                      <p className="note">The task types may include: multiple choice questions, identifying information, Identifying writer’s views/claims, Matching information, Matching headings, matching features, matching sentence endings, sentence completion, Summary, note, table, fow-chart completion, Diagram label completion, and Short-answer questions. </p>
                    </div>
                    <p class="content-disclaimer mb-0">Each question carries one mark.</p>
                    <p class="content-disclaimer" style={{color: '#000'}}><strong>Scoring scale:</strong> <span style={{fontSize: '15px'}}>0-9 brands</span></p>
                    <div class="d-flex align-items-center">
                      <button class="trymock-btn">TRY MOCK TEST</button>
                      <div class="free-label">FREE!</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
)

export default ReadingModule
